'use client';
import { api } from '@/lib/providers/axios/api';
import { API_ROUTES } from '@/shared/constants/api-routes';
import { buildApiRoute } from '@/shared/functions/build-api-route';
import type { BaseDates } from '@/shared/interfaces/base-dates';
import type { DefaultPaginatedResponse } from '@/shared/interfaces/default-paginated-response';
import type { DefaultPaginationParams } from '@/shared/interfaces/default-pagination-params';
import type { Media } from '../../medias/get-blob';

export interface Faq extends BaseDates {
	id: string;
	order: number;
	question: string;
	answer: string;
	active: boolean;
	medias?: Array<Media>;
}

export interface GetAllFaqsQueryParams extends DefaultPaginationParams {
	active?: 'true' | 'false';
}

export async function getAllFaqs({ active, search, page = 1, quantity = 5 }: GetAllFaqsQueryParams): Promise<DefaultPaginatedResponse<Array<Faq>>> {
	const res = await api.get(buildApiRoute(API_ROUTES.GET.PUBLIC.GET_ALL_FAQS), { params: { active, search, page, quantity } });
	return res.data;
}
